import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './App';
import { SocketProvider } from './contexts/SocketContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Suppress ResizeObserver errors in development
window.addEventListener('error', (e) => {
  const isResizeObserverError = 
    e.message?.includes('ResizeObserver') || 
    e.error?.message?.includes('ResizeObserver') ||
    e.message === 'Script error.'; // Sometimes ResizeObserver is masked as Script error

  if (isResizeObserverError) {
    e.stopImmediatePropagation();
    try {
      e.preventDefault();
      const resizeObserverErrorEvent = new ErrorEvent('error', {
        error: e.error,
        message: e.message,
      });
      resizeObserverErrorEvent.stopImmediatePropagation();
    } catch (err) {
      // Ignore
    }
  }
});

// Also handle unhandled promise rejections
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes('ResizeObserver')) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);